"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitTracker = void 0;
const api_1 = require("./utils/api");
const context_1 = require("./utils/context");
const url_1 = require("./utils/url");
const URL_PARAMS_SESSION_KEY = "urlParams";
const EXTERNAL_URL_PARAM_COOKIE_KEY = "external_url_params";
var OPERATION_ENUM;
(function (OPERATION_ENUM) {
    OPERATION_ENUM["CREATE"] = "CREATE";
    OPERATION_ENUM["UPDATE"] = "UPDATE";
    OPERATION_ENUM["NOOP"] = "NOOP";
})(OPERATION_ENUM || (OPERATION_ENUM = {}));
class VisitTracker {
    constructor() {
        this.apiDomain = "";
        this.successCallback = null;
        this.errorCallback = null;
        this.isFromWordPress = false;
        this.operation = OPERATION_ENUM.CREATE;
        const urlParamsValue = sessionStorage.getItem(URL_PARAMS_SESSION_KEY);
        this.urlParams = urlParamsValue ? JSON.parse(urlParamsValue) : undefined;
    }
    /**
     * Method used to initialize the Visit Tracker.
     */
    init(apiDomain, sessionCookieDomain, successCallback, errorCallback, isFromWordPress = false) {
        this.apiDomain = apiDomain;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        this.isFromWordPress = isFromWordPress;
        const urlParamsSet = !!this.urlParams;
        let { URL: url } = document;
        let referrer = document.referrer || "none";
        let extractNewUrlParams = true;
        if (urlParamsSet) {
            if (url_1.isReferrerFromNoom()) {
                // Case where user goes from LP -> payment -> add ons, etc.
                // Make sure we continue using stored url params.
                this.operation = OPERATION_ENUM.NOOP;
                // Only update if we have explicitly passed utm
                extractNewUrlParams = false;
            }
            else {
                // Case where user has entered our buyflow, goes out and then returns again
                // in the same session. Do an update to catch the case where they might be
                // coming back with new url parameters (e.g. clicked different facebook ad).
                // Backend will compare and create a new visit only if necessary.
                this.operation = OPERATION_ENUM.UPDATE;
            }
        }
        else if (context_1.isUserExternal(EXTERNAL_URL_PARAM_COOKIE_KEY)) {
            // Case where visit was created externally and stored in the cookie.
            // Extract visit info from the cookie instead of the document url.
            this.operation = OPERATION_ENUM.NOOP;
            [url, referrer] = url_1.extractFromExternalParams(sessionCookieDomain, EXTERNAL_URL_PARAM_COOKIE_KEY);
        }
        // Extract and store new url parameters if needed.
        if (extractNewUrlParams) {
            this.extractUrlParams(url, referrer);
        }
    }
    createOrUpdateVisit() {
        // Don't create a visit if we are a bot.
        if (context_1.isUserABot()) {
            return;
        }
        const additionalParams = {
            ...context_1.formatMeristemExperimentStateVisitData(),
        };
        if (this.operation === OPERATION_ENUM.CREATE) {
            api_1.updateVisit(this.apiDomain, true, this.urlParams, additionalParams, this.successCallback, this.errorCallback, this.isFromWordPress);
        }
        else if (this.operation === OPERATION_ENUM.UPDATE ||
            Object.keys(additionalParams).length !== 0) {
            api_1.updateVisit(this.apiDomain, false, this.urlParams, additionalParams, this.successCallback, this.errorCallback, this.isFromWordPress);
        }
        this.operation = OPERATION_ENUM.NOOP;
    }
    /**
     * Updates the current visit session when new URL parameters are added.
     */
    updateTrackingParams(urlParams) {
        var _a;
        url_1.updateURLParams(urlParams);
        const { URL: url } = document;
        this.extractUrlParams(url, (_a = this.urlParams) === null || _a === void 0 ? void 0 : _a.referrer);
        this.operation = OPERATION_ENUM.UPDATE;
        this.createOrUpdateVisit();
    }
    getTrackingParams() {
        return this.urlParams;
    }
    getVisitMixpanelProperties() {
        const urlParams = this.getTrackingParams();
        const utmParamsMapping = {
            utm_source: "UTM Source - Current",
            utm_medium: "UTM Medium - Current",
            utm_campaign: "UTM Campaign - Current",
            utm_content: "UTM Content - Current",
            utm_term: "UTM Term - Current",
            referrer: "Referrer URL",
        };
        const mixpanelProperties = {};
        Object.keys(urlParams || {}).forEach((paramKey) => {
            if (paramKey in utmParamsMapping) {
                const mappingKey = paramKey;
                mixpanelProperties[utmParamsMapping[mappingKey]] = urlParams[paramKey];
            }
            else {
                mixpanelProperties[paramKey] = urlParams[paramKey];
            }
        });
        return mixpanelProperties;
    }
    extractUrlParams(rawUrl, referrer) {
        const url = new URL(rawUrl);
        const searchParams = new URLSearchParams(url.search);
        const formattedUrlParams = {
            initialUrl: `${url}`,
            referrer,
            utm_source: url_1.extractUtmSource(searchParams, referrer, this.urlParams),
        };
        searchParams.forEach((value, key) => {
            if (!formattedUrlParams[key]) {
                formattedUrlParams[key] = value;
            }
        });
        this.urlParams = formattedUrlParams;
        sessionStorage.setItem(URL_PARAMS_SESSION_KEY, JSON.stringify(this.urlParams));
        return formattedUrlParams;
    }
}
exports.VisitTracker = VisitTracker;
const visitTracker = new VisitTracker();
exports.default = visitTracker;
//# sourceMappingURL=visitTracker.js.map